module.exports = __webpack_public_path__ + "img/banner-nectios.ff69a21c.png";